import React from "react";
import { Route, Redirect } from "react-router-dom";
import { checkLoginCookie } from "../../auth/checkLoginCookie";

function PrivateRoute({ children, ...rest }) {
  let auth = checkLoginCookie();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
